import { useAuthStore } from '../../store/authStore';
import { OpleiderRol, isOpleiderRol } from './opleiderMenu';

/** Rol van de ingelogde opleidersgebruiker (login-respons of /auth/me → user.opleider_rol). */
export function useOpleiderRol(): OpleiderRol | null {
  const { user } = useAuthStore();
  return isOpleiderRol(user?.opleider_rol) ? user.opleider_rol : null;
}

export const ROL_KLEUR: Record<OpleiderRol, string> = {
  OWNER: 'bg-amber-400/20 text-amber-200 border-amber-300/40',
  ADMINISTRATOR: 'bg-sky-400/20 text-sky-100 border-sky-300/40',
  TRAINER: 'bg-emerald-400/20 text-emerald-100 border-emerald-300/40',
};
